import { BarChart, Close, Fullscreen, GetApp, PieChart, ShowChart, Sort, TableChart, Image, Info, Person } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import { IFilterKeys, IFilters } from "models/core";
import { downloadAsImage, downloadFile } from "models/core/core";
import { extractFilterLabel } from "models/mdt";
import { PlotData } from "plotly.js";
import React from "react";
import { DataToCSV } from "./DataToCSV";

interface IProps {
    vbar?: boolean;
    hbar?: boolean;
    table?: boolean;
    scatter?: boolean;
    pie?: boolean;
    person?: boolean;
    downloadAsCsv?: boolean;
    downloadAsPng?: boolean;
    isFullScreen?: boolean;
    viewAsFullScreen?: boolean;
    tooltipInfo?: boolean;
    tooltipText?: string[];
    chartOrientation: string;
    chartType: string;
    traces: Partial<PlotData>[];
    xLabel: string;
    yLabel: string;
    title: string;
    setChartType: Function;
    setChartOrientation: Function;
    setFullScreen: Function;
    currentFilters: IFilters<IFilterKeys>;
}

/**
 * Component to create the icons that will appear in the top right corner of the dash paper
 * In the chart file, we set true or false to each icon to decide if it will show
 */

export class ChartIcons extends React.Component<IProps, any> {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { vbar,   
                hbar, 
                table, 
                scatter, 
                pie, 
                person,
                downloadAsCsv, 
                downloadAsPng, 
                viewAsFullScreen, 
                isFullScreen, 
                tooltipInfo,
                tooltipText,
                chartOrientation, 
                chartType, 
                traces, 
                xLabel, 
                yLabel, 
                title, 
                setChartType, 
                setChartOrientation,
                setFullScreen,
                currentFilters } = this.props;

        //Create function to show table option
        const showTable = () => {
            setChartType("table"), setChartOrientation("v");
        };

        //Create function to show bar chart option
        const showBarChart = () => {
            setChartType("bar"), setChartOrientation("v");
        };

        //Create function to show horizontal bar chart option
        const showHorizontalBarChart = () => {
            setChartType("bar"), setChartOrientation("h");
        };

        //Create function to show pie chart option 
        const showPieChart = () => {
            setChartType("pie"), setChartOrientation("v");
        };

        //Create function to show line chart option 
        const showLineChart = () => {
            setChartType("scatter"), setChartOrientation("v");
        };

        //Create function to show person chart option 
        const showPersonChart = () => {
            setChartType("person"), setChartOrientation("h");
        };

        //Create function to show fullscreen option
        const showChartFullscreen = () => {
            setFullScreen(true);
        };

        //Create function to close fullscreen option
        const closeChartFullscreen = () => {
            setFullScreen(false);
        };


        return (
            <div style={{paddingTop: "5px", paddingRight: "5px", float: "right" }}>

                    {(vbar ? <Tooltip title="Vertical Bar Chart">  
                        <BarChart
                            onClick={_ => showBarChart()} 
                                style={{ cursor: "pointer", 
                                        color: (chartType == "bar" && chartOrientation =="v" ? "#1e88e5": "gray"), 
                                        padding: "1px",
                                        fontSize: 20, 
                                        }} 
                        />
                    </Tooltip> : null)}

                    {(hbar ? <Tooltip title="Horizontal Bar Chart">  
                        <Sort
                            onClick={_ => showHorizontalBarChart()} 
                                style={{ cursor: "pointer", 
                                        color: (chartType == "bar" && chartOrientation =="h" ? "#1e88e5": "gray"), 
                                        padding: "1px",
                                        fontSize: 20, 
                                        }} 
                        />
                    </Tooltip> : null)}

                    {(table ? <Tooltip title="Table">
                        <TableChart
                                onClick={_ => showTable()} 
                                style={{ cursor: "pointer",
                                        color: (chartType == "table" ? "#1e88e5": "gray"),
                                        padding: "1px", 
                                        fontSize: 20, 
                                        }} 
                        />
                    </Tooltip> : null)}
                
                    {(scatter ? <Tooltip title="Line Chart">
                        <ShowChart  
                                onClick={_ => showLineChart()} 
                                style={{ cursor: "pointer",
                                        color: (chartType == "scatter" ? "#1e88e5": "gray"),  
                                        padding: "1px",
                                        fontSize: 20, 
                                    }} 
                        />
                    </Tooltip> : null)}

                    {(pie ? <Tooltip title="Pie Chart">
                        <PieChart
                                onClick={_ => showPieChart()} 
                                style={{ cursor: "pointer",
                                        color: (chartType == "pie" ? "#1e88e5": "gray"), 
                                        padding: "1px",
                                        fontSize: 20, 
                                        }} 
                        />
                    </Tooltip> : null)}

                    {(person ? <Tooltip title="Person Chart">
                        <Person
                            onClick={_ => showPersonChart()} 
                            style={{
                                cursor: "pointer",
                                color: (chartType == "person" ? "#1e88e5": "gray"),
                                padding: "1px",
                            }}
                        />
                    </Tooltip> : null)}

                    {(downloadAsCsv ?
                        <Tooltip title="Download as csv">
                            <GetApp
                                    onClick={_ => downloadFile(DataToCSV(traces, 
                                                                            chartType,
                                                                            chartOrientation, 
                                                                            xLabel, 
                                                                            yLabel, 
                                                                            title,
                                                                            currentFilters,
                                                                            ), 
                                                                        title+'.csv', 
                                                                        'text/csv;charset=utf-8;'
                                                                        )} 
                                    style={{ cursor: "pointer",
                                            color: "gray", 
                                            padding: "1px",
                                            fontSize: 20, 
                                            }} 
                            />
                        </Tooltip> : null)}

                        {(downloadAsPng ?
                        <Tooltip title="Download as png">
                            <Image
                                    onClick={_ => 
                                        downloadAsImage(_.currentTarget.parentElement.parentElement.parentElement.parentElement,
                                                        title+'.png',
                                                        isFullScreen,
                                                        extractFilterLabel(currentFilters, " | "))                                                                
                                                            } 
                                    style={{ cursor: "pointer",
                                            color: "gray", 
                                            padding: "1px",
                                            fontSize: 20, 
                                            }} 
                            />
                        </Tooltip> : null)}

                    {(viewAsFullScreen && window.innerWidth > 991 && !isFullScreen ? 
                        <Tooltip title="View as full-screen">
                            <Fullscreen
                                    onClick={_ => showChartFullscreen()} 
                                    style={{ cursor: "pointer",
                                            color: "gray", 
                                            padding: "1px",
                                            fontSize: 20, 
                                            }} 
                            />
                        </Tooltip> : null)}

                    {(viewAsFullScreen && window.innerWidth > 991 && isFullScreen ? 
                        <Tooltip title="Close full-screen">
                            <Close
                                    onClick={_ => closeChartFullscreen()} 
                                    style={{ cursor: "pointer", 
                                            color: "gray", 
                                            padding: "1px",
                                            fontSize: 20,
                                            }} 
                            />
                        </Tooltip> : null)}

                    {(tooltipInfo ? 
                        <Tooltip title= {
                            <React.Fragment>
                                {tooltipText.map(a => 
                                <Typography color="inherit" key={a}>{a} <br/> </Typography>
                                )}                      
                            </React.Fragment> 
                            }>
                            <Info style={{ cursor: "pointer",
                                    fontSize: 20,
                                    padding: "1px",
                                    color: "gray"
                                    }}  />
                        </Tooltip> : null)}

                </div>
        )
    }
}

            